export enum APP_PAGES {
  SEARCH = "/search",
  CUSTOMER_DETAILS = "/:name",
  RESOURCES = "/resources",
  CUSTOMERS_HOME = "/customers",
  // Document routes (served at app root)
  DOCS = "/",
  DOCS_LIBRARY = "/library",
  DOCS_UPLOAD = "/upload",
  DOCS_DETAIL = "/doc/:id",
}

/** Paths that belong to the documents experience (not customer search). */
export const DOCS_PATH_PREFIXES = ["/", "/library", "/upload", "/doc"] as const;

export const isDocsPath = (pathname: string): boolean =>
  pathname === "/" ||
  pathname.startsWith("/library") ||
  pathname.startsWith("/upload") ||
  pathname.startsWith("/doc/");
